'use client';
import { useContext } from 'react';
import { EpgEventTeaser } from 'components/UI/EpgEventTeaser';
import { AppContext } from 'context/AppContext';
import { useNoNav } from 'hooks/useNoNav';
import { useQueryParam } from 'hooks/useQueryParam';
import type { EpgEntry } from 'utils/epg';
import { isFeatureFlagEnabled } from 'utils/featureFlags';
import styles from './rtl-plus-event.module.scss';

export type WidgetEpgRtlPlusEventProps = {
  readonly items: ReadonlyArray<EpgEntry>;
};

export const WidgetEpgRtlPlusEvent = ({ context }: { context: WidgetEpgRtlPlusEventProps }) => {
  const noNav = useNoNav();
  const showRtlPlusEventTeaser = useQueryParam('rtlPlusEventTeaser');
  const { featureFlags } = useContext(AppContext);
  const isWidgetEnabled = isFeatureFlagEnabled('ft_epg_rtl_plus_event_teaser', featureFlags) || showRtlPlusEventTeaser;

  if (noNav || !isWidgetEnabled) return null;

  const items = context.items.map((item) => {
    const { broadcastService, alternateName, name } = item.model.fields.fields;

    return {
      channelName: broadcastService ?? '',
      showName: alternateName ?? name,
    };
  });

  return <EpgEventTeaser className={styles.root} items={items} />;
};
